export default {
    inquiry: 'Inquiry',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    employeeId: 'Employee ID',
    employeeFullname: 'Name Surname',
    email: 'Email address',
    position: 'Position',
    bureau: 'Bureau',
    approve: 'Approve',
    reject: 'Reject',
    pending: 'Pending',
    inquiryStatus: 'Inquiry Status',
    description: 'Description',
    attachment: 'Attachment',
    downloadFile: 'Download File',
    date: 'Date',
    approvedBy: 'Approved By',
    rejectedBy: 'Rejected By',
    congratulation: 'Congratulation',
    errorMessage: 'Something went wrong'
}
